// ---------------------------------------------------------------------------
// ChannelCard — orchestrator. Composes Header / Metrics / Sparkline / Footer.
// ---------------------------------------------------------------------------

import React from 'react';
import { ChannelCardHeader } from './ChannelCardHeader';
import { ChannelCardMetrics } from './ChannelCardMetrics';
import { ChannelCardSparkline } from './ChannelCardSparkline';
import { ChannelCardFooter } from './ChannelCardFooter';
import type { ChannelCardProps } from '../types';

export function ChannelCard({
  channel,
  miniChartDataByMetric,
  periodLabel,
  period,
  isPeriodLoading,
}: ChannelCardProps) {
  return (
    <div className="rounded-xl border border-v11-border bg-v11-surface overflow-hidden hover:border-v11-border-hover transition-colors">
      <ChannelCardHeader channel={channel} period={period} />
      <ChannelCardMetrics channel={channel} period={period} sparklineData={miniChartDataByMetric} isPeriodLoading={isPeriodLoading} />
      <ChannelCardSparkline
        dataByMetric={miniChartDataByMetric}
        period={period}
        periodLabel={periodLabel}
      />
      <ChannelCardFooter channel={channel} />
    </div>
  );
}
